module.exports = __webpack_public_path__ + "img/gen-rocket-3.caf5e1bb.jpg";